module.exports = __webpack_public_path__ + "media/images/yahoo_japan_icon-eda9eec43826ad253c22500c71cef50b.png";